import { create } from 'zustand';

const useSearchStore = create((set) => ({
  results: {},
  clear: () => set(() => ({ results: {} })),

  query: '',
  mode: 'global',
  localSearch: null,

  setQuery: (query) => set({ query }),
  setMode: (mode) => set({ mode }),

  registerLocalSearch: (config) =>
    set({ localSearch: config, mode: 'local', query: '', results: {} }),
  unregisterLocalSearch: () =>
    set({ localSearch: null, mode: 'global', query: '' }),
}));

export default useSearchStore;
